const KAKAO_API_KEY = 'fea2f292d96de03099e8264c991f57eb';
